import type { ReactNode } from "react";
import { useEffect } from "react";

import { useThemeParams } from "../hooks/useThemeParams.js";

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Mirror Telegram's themeParams onto CSS custom properties at the
 * document root so plain CSS / Tailwind utilities can consume them.
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  const { params, scheme } = useThemeParams();

  useEffect(() => {
    const root = document.documentElement;
    const map: Record<string, string | undefined> = {
      "--tg-bg": params.bg_color,
      "--tg-text": params.text_color,
      "--tg-hint": params.hint_color,
      "--tg-link": params.link_color,
      "--tg-button": params.button_color,
      "--tg-button-text": params.button_text_color,
      "--tg-secondary-bg": params.secondary_bg_color,
      "--tg-header-bg": params.header_bg_color,
      "--tg-accent-text": params.accent_text_color,
      "--tg-section-bg": params.section_bg_color,
    };
    for (const [k, v] of Object.entries(map)) {
      if (v) root.style.setProperty(k, v);
    }
    root.dataset.theme = scheme;
    root.classList.remove("light", "dark");
    root.classList.add(scheme);
    root.style.colorScheme = scheme;
  }, [params, scheme]);

  return <>{children}</>;
}
